import { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

export const MatchedKeywordsCell = ({ matchedKeywords }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    if (!matchedKeywords?.length) {
        return null;
    }

    const handlePopoverOpen = (event) => setAnchorEl(event.currentTarget);
    const handlePopoverClose = () => setAnchorEl(null);
    const handleChipClick = (event) =>
        setAnchorEl((current) => (current ? null : event.currentTarget));

    return (
        <Box onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
            <Chip
                size="small"
                variant="outlined"
                sx={{ cursor: "pointer" }}
                onClick={handleChipClick}
                label={`${matchedKeywords.length} keyword${
                    matchedKeywords.length > 1 ? "s" : ""
                } matched`}
            />
            <Popover
                sx={{ pointerEvents: "none" }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <div
                    style={{
                        padding: "8px 12px",
                        maxHeight: 240,
                        overflowY: "auto",
                        minWidth: 160,
                    }}
                >
                    {matchedKeywords.map(({ keyword, count }, index) => (
                        <Stack
                            key={`${keyword}-${index}`}
                            direction="row"
                            alignItems="baseline"
                            spacing={1}
                            sx={{ py: "2px" }}
                        >
                            <Typography
                                variant="body2"
                                sx={{ whiteSpace: "nowrap" }}
                            >
                                {keyword}
                            </Typography>
                            <Box
                                sx={{
                                    flex: 1,
                                    mb: "3px",
                                    borderBottom: "1px dotted",
                                    borderColor: "text.disabled",
                                }}
                            />
                            <Typography variant="body2" color="text.secondary">
                                {count} occurrence{count > 1 ? "s" : ""}
                            </Typography>
                        </Stack>
                    ))}
                </div>
            </Popover>
        </Box>
    );
};

export default MatchedKeywordsCell;
